import React, { useState, useEffect } from 'react';
import './Members.css';

import ankitaPhoto from '../assets/Ankita_Sahoo.jpeg';
import vridhiPhoto from '../assets/Vridhi_Singh.jpg';
import niketaPhoto from '../assets/Niketa_Sinha.png';
import kodieswaranPhoto from '../assets/Kodies_Waran.jpg';
import riaPhoto from '../assets/Ria_Goswami.jpeg';
import chevellaPhoto from '../assets/Chevalla_Maheshwari.jpeg';
import amruthaPhoto from '../assets/Amrutha_Krishnamoorthy.jpg';
import rajatPhoto from '../assets/RaJat_LeKhak.jpg';
// import sanuPhoto from '../assets/sanu_awasthi.png';
import siddhantPhoto from '../assets/Siddhant_Biswas.jpg';
import victoriaPhoto from '../assets/Victoria_John.jpg';
import truptiPhoto from '../assets/Trupti_Sahoo.jpg';
import tanushreePhoto from '../assets/Tanushree_Deshmukh.jpg';
import abhinavPhoto from '../assets/Abhinav_saji.jpg';
import mosamPhoto from '../assets/Mosam.jpeg';
import ruchaliPhoto from '../assets/Ruchali_Tayade.jpg';
import smritiPhoto from '../assets/Smriti_Marjara.jpg';
import anuradhaPhoto from '../assets/Anuradha_Kirtonia.jpg';
import tanmayPhoto from '../assets/Tanmay_Jadhav.jpg';
import sayantiPhoto from '../assets/Sayanti_Shome.jpg';
import souradeepPhoto from '../assets/SOURADEEP_DEY.JPG';
import britlinPhoto from '../assets/Britlin_Deva_Jebasta_.N.jpeg';
import simantaPhoto from '../assets/Dr._Simanta_Patra.jpeg';
import chitraPhoto from '../assets/Chitra_jaiswal1.jpg';
import parijat from '../assets/parijat.jpeg';
import semimPhoto from '../assets/semimahmed.jpeg'
import priyankaPhoto from '../assets/Priyanka.jpeg'
import ahanaPhoto from '../assets/Ahana.png'
import mereenaPhoto from '../assets/Mereena.jpg'
import indujaPhoto from '../assets/Induja.jpeg'
import indranilPhoto from '../assets/Indranil.jpg'  
import aniruddhaPhoto from '../assets/Aniruddha.jpg'  
import PravinB from '../assets/PravinB.jpeg'

const Members = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedMember, setSelectedMember] = useState(null);
  const [expandedCategories, setExpandedCategories] = useState({
    'Postdoctoral Fellows': true,
    'PhD Scholars': true,
    'M.Tech Students': true,
    'Trainees': true,
    'Project Technical Support': true,
  });

  // Hierarchical order of categories (sorted by priority)
  const categoryOrder = [
    'Postdoctoral Fellows',
    'PhD Scholars',
    'M.Tech Students',
    'Interns',
    'Project Technical Support',
  ];

  // Complete member data organized by category with CORRECTED research interests
  const membersData = {
    'Postdoctoral Fellows': [
      {
        id: 23,
        name: 'Dr. Srimanta Patra',
        position: 'DST INSPIRE Faculty',
        qualification: 'Ph.D., NIT Rourkela',
        researchArea: 'Cancer biology, Autophagy, Mitochondrial and Lysosomal dynamics ',
        dateJoined: '2025',
        email: 'spinspire_3428@iitg.ac.in',
        linkedin: '',
        image: simantaPhoto,
        awards: []
      },
      {
        id: 23,
        name: 'Dr. Semim Akhtar Ahmed',
        position: 'National Post-Doctoral Fellow',
        qualification: 'Ph.D. in Biological Sciences, Institute of Advanced Study in Science & Technology, Assam, India',
        researchArea: 'Metabolic Disorders, Molecular PharmacologyCancer Biology, 3D in vitro modelling, Drug screening',
        dateJoined: '2025',
        email: 'semimahmed2018@iitg.ac.in',
        linkedin: '',
        image: semimPhoto,
        awards: []
      },
      {
        id: 23,
        name: 'Dr. Priyanka Dash',
        position: 'National Post-Doctoral Fellow' ,
        qualification: 'Ph.D. in Life Sciences, NIT Rourkela',
        researchArea: 'Nanotechnology, Drug Delivery',
        dateJoined: '2026',
        email: 'priyadash@iitg.ac.in',
        linkedin: '',
        image: priyankaPhoto,
        awards: []
      },
    ],
    'PhD Scholars': [
      // {
      //   id: 9,
      //   name: 'Chitra Jaiswal',
      //   position: 'PhD Scholar',
      //   qualification: 'M.Sc. Molecular and Human Genetics, BHU',
      //   researchArea: '3D in vitro cancer model, drug delivery, drug screening, Hydrogel, Microfluidic, 3D Bioprinting',
      //   dateJoined: '7/22/2025',
      //   email: 'chitra.jaiswal@iitg.ac.in',
      //   linkedin: '',
      //   image: chitraPhoto,
      //   awards: ['Travel Award in 12th World Biomaterials Congress (WBC) 2024, Daegu, Republic of Korea']
      // },
      // {
      //   id: 2,
      //   name: 'Souradeep Dey',
      //   position: 'PhD Scholar',
      //   qualification: 'M.Sc. Biotechnology, VIT Vellore',
      //   researchArea: 'Microphysiological models',
      //   dateJoined: '7/20/2019',
      //   email: 'deepdey1994@gmail.com',
      //   linkedin: 'https://www.linkedin.com/in/souradeep-dey-9681081352/',
      //   image: souradeepPhoto,
      //   awards: ['Prime Minister\'s Research Fellowship 2020, by MoE India']
      // },
      {
        id: 11,
        name: 'Sayanti Shome',
        position: 'PhD Scholar',
        qualification: 'M.Tech. Nanotechnology, Department of Physics, NIT Kurukshetra',
        researchArea: 'Bone regeneration, Bioactive scaffolds, In Vitro Models, Osteoporosis',
        dateJoined: '7/22/2025',
        email: 'sayanti.shome@iitg.ac.in',
        linkedin: '',
        image: sayantiPhoto,
        awards: []
      },
      {
        id: 3,
        name: 'Kodieswaran M',
        position: 'PhD Scholar',
        qualification: 'M.Sc., Microbiology, Rank Holder, Alagappa University, Tamil Nadu',
        researchArea: 'Wound healing technologies, Skin tissue engineering',
        dateJoined: '1/4/2022',
        email: 'kodieswaran.m@iitg.ac.in',
        linkedin: '',
        image: kodieswaranPhoto,
        awards: ['Prime Minister\'s Research Fellowship 2022, MoE India']
      },
      {
        id: 4,
        name: 'Rajat Dadheech',
        position: 'PhD Scholar',
        qualification: 'M.Sc. Applied Microbiology, VIT Vellore',
        researchArea: 'Drug Delivery, Cancer, Hydrogels, 3D In Vitro Models, Bioprinting',
        dateJoined: '2/1/2022',
        email: 'rajat.dadheech@iitg.ac.in',
        linkedin: '',
        image: rajatPhoto,
        awards: ['INSPIRE Fellowship 2022, by DST India']
      },
      {
        id: 6,
        name: 'Chevella Maheshwari',
        position: 'PhD Scholar',
        qualification: 'M.Pharm.  Biotechnology, NIPER, Hajipur',
        researchArea: 'Cartilage tissue regenerative therapeutic for osteoarthritis treatment',
        dateJoined: '7/26/2022',
        email: 'chevella.maheshwari@iitg.ac.in',
        linkedin: '',
        image: chevellaPhoto,
        awards: ['PMRF on 2023 by MoE']
      },
      {
        id: 7,
        name: 'Victoria J',
        position: 'PhD Scholar',
        qualification: 'M.Tech. Biotechnology, Motilal Nehru National Institute of Technology Allahabad',
        researchArea: 'In-vitro skin models, Wound healing, Electronic Bandages',
        dateJoined: '7/24/2023',
        email: 'victoria.j@iitg.ac.in',
        linkedin: '',
        image: victoriaPhoto,
        awards: ['Gold Medalist_MTech_Biotechnology_2023']
      },
      {
        id: 24,
        name: 'Ankita Sahoo',
        position: 'PhD Scholar',
        qualification: 'M.Sc. Biotechnology, Utkal University',
        researchArea: 'Heart valve tissue engineering',
        dateJoined: '7/22/2024',
        email: 'ankita.sahoo@iitg.ac.in',
        linkedin: 'https://www.linkedin.com/in/ankita-sahoo-0a6250165',
        image: ankitaPhoto,
        awards: []
      },
      {
        id: 8,
        name: 'Niketa Sinha',
        position: 'PhD Scholar',
        qualification: 'M.Sc. in Molecular Biology and Biotechnology, Tezpur University',
        researchArea: 'Liver Tissue Engineering',
        dateJoined: '1/1/2025',
        email: 'niketa.sinha@iitg.ac.in',
        linkedin: '',
        image: niketaPhoto,
        awards: []
      },
      {
        id: 10,
        name: 'Vridhi Singh',
        position: 'PhD Scholar',
        qualification: 'M.Sc. Virology, ICMR-National Institute of Virology',
        researchArea: 'In vitro disease study for Liver',
        dateJoined: '7/22/2025',
        email: 'vridhi.singh@iitg.ac.in',
        linkedin: '',
        image: vridhiPhoto,
        awards: []
      },
      {
        id: 11,
        name: 'Siddhant Biswas',
        position: 'PhD Scholar',
        qualification: 'M.Sc. Biotechnology (Gold Medalist), Institute of Advanced Research (IAR) Gandhinagar, Gujarat' ,
        researchArea: 'Oncobiology, Cancer-on-chip models, Regenerative Medicine, 3D in vitro tumor models, Tumor Tissue Engineering',
        dateJoined: '7/22/2025',
        email: 'b.siddhant@iitg.ac.in',
        linkedin: 'https://www.linkedin.com/in/siddhant-biswas-b92471190',
        image: siddhantPhoto,
        awards: ['GATE Fellowship 2025, MoE']
        
      },
      {id: 12,
        name: 'Amrutha K',
        position: 'PhD Scholar',
        qualification: 'M.Tech. Medical Nanotechnology, SASTRA University, Thanjavur, Tamil Nadu',
        researchArea: 'In Vitro 3D Models',
        dateJoined: '7/22/2025',
        email: 'amrutha.k@iitg.ac.in',
        linkedin: '',
        image: amruthaPhoto,
        awards: []
        
      },
      {id: 13,
        name: 'Ahana Mukherjee ',
        position: 'PhD Scholar',
        qualification: 'M.Sc., Molecular Microbiology,  Presidency University, Kolkata',
        researchArea: 'Cancer',
        dateJoined: '7/22/2026',
        email: 'ahanamukherj@iitg.ac.in',
        linkedin: '',
        image: ahanaPhoto,
        awards: ['GATE Fellowship 2026, MoE']
      },
      {id: 14,
        name: 'Mereena Roy  ',
        position: 'PhD Scholar',
        qualification: 'M.Sc. Stem Cells and Regenerative Medicine, D.Y. Patil Education Society, Kolhapur',
        researchArea: '3D in vitro Skin Model',
        dateJoined: '7/22/2026',
        email: 'mereenaroy@iitg.ac.in',
        linkedin: '',
        image: mereenaPhoto,
        awards: ['GATE Fellowship 2026, MoE']
      },
      // {
      //   id: 5,
      //   name: 'Sanu Awasthi',
      //   position: 'PhD Scholar',
      //   qualification: 'MSc (honours) in Biology, Centre for Basic Sciences, PtRSU Raipur Chhattisgarh',
      //   researchArea: '3D In vitro liver Models, Biomaterials, Stem Cells',
      //   dateJoined: '7/25/2022',
      //   email: 'sanu.awasthi@iitg.ac.in',
      //   linkedin: '',
      //   image: sanuPhoto,
      //   awards: []
      // }
    ],
    'M.Tech Students': [
      {
        id: 15,
        name: 'Induja Samanta ',
        position: 'M.Tech. Student',
        qualification: 'B.Tech. Biotechnology, Bengal Institute of Technology, MAKAUT',
        researchArea: 'Sustainable and plastic free functional coating on paper based packaging',
        dateJoined: '3/21/2026',
        email: 's.induja@iitg.ac.in',
        linkedin: 'https://www.linkedin.com/in/sinduja2019/',
        image: indujaPhoto,
        awards: []
      },
      {
        id: 16,
        name: 'Indranil Ghosh',
        position: 'M.Tech. Student',
        qualification: 'B.Tech Biotechnology, Heritage Institute of Technology, Kolkata',
        researchArea: 'Microfluidic 3D in vitro tumor models, Cancer-on-a-Chip, , Tissue Engineering',
        dateJoined: '6/10/2026',
        email: 'g.indranil@iitg.ac.in',
        linkedin: '',
        image: indranilPhoto,
        awards: []
      },
      {
        id: 17,
        name: 'Pravin Kumar B',
        position: 'M.Tech. Student',
        qualification: 'B.Tech Biotechnology, SASTRA Deemed to be University, Thanjavur, Tamil Nadu',
        researchArea: 'Computational Fluid Dynamics (CFD), 3D in vitro Model Design, Organ-on-a-Chip, Microfluidic Flow Modeling, Computational Bioengineering',
        dateJoined: '1/15/2026',
        email: 'b.pravin@iitg.ac.in',
        linkedin: 'https://www.linkedin.com/in/pravin-kumar-b-5274361a2',
        image: PravinB,
        awards: ['GATE Fellowship 2026, MoE']
      },
    ], 
    'Interns': [
      {
        id: 18,
        name: 'Aniruddha Pal ',
        position: 'Intern ( Master Thesis Student )',
        qualification: 'BS-MS Biological Sciences (IISER Berhampur)',
        researchArea: 'Organ-on-a-Chip, Microfluidic 3D in vitro models, Tissue Engineering ',
        dateJoined: '6/9/2026',
        email: 'aniruddha22@iiserbpr.ac.in',
        linkedin: '',
        image: aniruddhaPhoto,
        awards: ['INSPIRE scholarship (2022-2027)']
      },
    ],
  };




  // Flatten all members for searching
  const allMembers = Object.values(membersData).flat();

  // Filter members based on search
  const getFilteredMembers = (categoryMembers) => {
    if (!searchTerm) return categoryMembers;
    
    return categoryMembers.filter(member =>
      member.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      member.researchArea.toLowerCase().includes(searchTerm.toLowerCase()) ||
      member.qualification.toLowerCase().includes(searchTerm.toLowerCase())
    );
  };

  const toggleCategory = (category) => {
    setExpandedCategories(prev => ({
      ...prev,
      [category]: !prev[category]
    }));
  };

  const openMemberModal = (member) => {
    setSelectedMember(member);
    document.body.style.overflow = 'hidden';
  };

  const closeMemberModal = () => {
    setSelectedMember(null);
    document.body.style.overflow = 'auto';
  };

  useEffect(() => {
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, []);

  // Function to get initials for placeholder
  const getInitials = (name) => {
    return name
      .split(' ')
      .map(n => n[0])
      .join('')
      .substring(0, 2)
      .toUpperCase();
  };

  return (
    <div className="members-page">
      <div className="members-container">
        {/* Page Header */}
        <section className="members-header">
          <h1 className="members-title">Research Team</h1>
          <p className="members-subtitle">
            Our dedicated team of researchers and students working at the forefront of biomaterials and tissue engineering
          </p>
        </section>

        {/* Statistics Bar */}
        <section className="members-stats-bar">
          <div className="stat-item">
            <span className="stat-value">{allMembers.length}</span>
            <span className="stat-label">Total Members</span>
          </div>
          {categoryOrder.map(category => (
            <div key={category} className="stat-item">
              <span className="stat-value">{(membersData[category] || []).length}</span>
              <span className="stat-label">{category.replace('M.Tech Students', 'M.Tech').replace('Project Technical Support', 'Technical').replace('DST INSPIRE Faculty', 'Faculty')}</span>
            </div>
          ))}
        </section>

        {/* Search Bar */}
        <section className="members-search-section">
          <div className="search-bar">
            <svg className="search-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <circle cx="11" cy="11" r="8"></circle>
              <path d="m21 21-4.35-4.35"></path>
            </svg>
            <input
              type="text"
              placeholder="Search by name, research area, or qualification..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="search-input"
            />
          </div>
        </section>

        {/* Hierarchical Members Display */}
        <section className="members-hierarchical">
          {categoryOrder.map(category => {
            const filteredCategoryMembers = getFilteredMembers(membersData[category] || []);
            
            if (filteredCategoryMembers.length === 0 && searchTerm) return null;
            
            return (
              <div key={category} className="category-section">
                <div 
                  className="category-header"
                  onClick={() => toggleCategory(category)}
                  role="button"
                  tabIndex={0}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      toggleCategory(category);
                    }
                  }}
                >
                  <h2 className="category-title">
                    {category}
                  </h2>
                  <svg 
                    className={`category-toggle ${expandedCategories[category] ? 'expanded' : ''}`}
                    viewBox="0 0 24 24" 
                    fill="none" 
                    stroke="currentColor"
                  >
                    <path d="M19 9l-7 7-7-7" />
                  </svg>
                </div>
                
                {expandedCategories[category] && (
                  <div className="category-members-grid">
                    {filteredCategoryMembers.map((member) => (
                      <div 
                        key={member.id} 
                        className="member-card" 
                        onClick={() => openMemberModal(member)} 
                        role="button" 
                        tabIndex={0} 
                        onKeyDown={(e) => { 
                          if (e.key === 'Enter') openMemberModal(member); 
                        }}
                      >
                        <div className="member-image-wrapper">
                          {member.image ? (
                            <img src={member.image} alt={member.name} className="member-image" />
                          ) : (
                            <div className="member-image-placeholder">
                              <span>{getInitials(member.name)}</span>
                            </div>
                          )}
                          {member.position === 'PhD Scholar' && member.awards.some(a => a.includes('PMRF') || a.includes('Prime Minister')) && (
                            <div className="pmrf-badge">PMRF</div>
                          )}
                        </div>
                        
                        <div className="member-info">
                          <h3 className="member-name">{member.name}</h3>
                          <p className="member-position">{member.position}</p>
                          <p className="member-qualification">{member.qualification}</p>
                          <div className="member-research">
                            {member.researchArea.split(',').slice(0, 2).map((area, index) => (
                              <span key={index} className="research-tag">{area.trim()}</span>
                            ))}
                          </div>
                        </div>

                        <div className="member-hover-info">
                          <button 
                            className="view-profile-btn" 
                            onClick={(e) => { 
                              e.stopPropagation(); 
                              openMemberModal(member); 
                            }}
                          >
                            View Full Profile
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            );
          })}
        </section>

        {/* No Results */}
        {searchTerm && allMembers.filter(member =>
          member.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
          member.researchArea.toLowerCase().includes(searchTerm.toLowerCase()) ||
          member.qualification.toLowerCase().includes(searchTerm.toLowerCase())
        ).length === 0 && (
          <div className="no-results">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="no-results-icon">
              <circle cx="11" cy="11" r="8"></circle>
              <path d="m21 21-4.35-4.35"></path>
            </svg>
            <p>No members found matching your criteria.</p>
            <button onClick={() => setSearchTerm('')} className="reset-btn">
              Clear Search
            </button>
          </div>
        )}

        {/* Member Detail Modal */}
        {selectedMember && (
          <div className="member-modal" onClick={closeMemberModal}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
              <button className="modal-close" onClick={closeMemberModal} aria-label="Close modal">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M18 6L6 18M6 6l12 12"/>
                </svg>
              </button>
              
              <div className="modal-header">
                <div className="modal-image-wrapper">
                  {selectedMember.image ? (
                    <img src={selectedMember.image} alt={selectedMember.name} />
                  ) : (
                    <div className="modal-image-placeholder">
                      <span>{getInitials(selectedMember.name)}</span>
                    </div>
                  )}
                </div>
                
                <div className="modal-header-info">
                  <h2>{selectedMember.name}</h2>
                  <p className="modal-position">{selectedMember.position}</p>
                  {selectedMember.dateJoined && (
                    <p className="modal-joined">Joined: {selectedMember.dateJoined}</p>
                  )}
                </div>
              </div>
              
              <div className="modal-body">
                <div className="modal-section">
                  <h4>Education</h4>
                  <p>{selectedMember.qualification}</p>
                </div>
                
                <div className="modal-section">
                  <h4>Research Interests</h4>
                  <div className="research-tags-list">
                    {selectedMember.researchArea.split(',').map((area, index) => (
                      <span key={index} className="research-tag-large">{area.trim()}</span>
                    ))}
                  </div>
                </div>

                {selectedMember.awards && selectedMember.awards.length > 0 && (
                  <div className="modal-section">
                    <h4>Awards & Recognitions</h4>
                    <ul className="awards-list">
                      {selectedMember.awards.map((award, index) => (
                        <li key={index}>{award}</li>
                      ))}
                    </ul>
                  </div>
                )}
                
                <div className="modal-footer">
                  {selectedMember.email && (
                    <a href={`mailto:${selectedMember.email}`} className="contact-link">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                        <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                        <polyline points="22,6 12,13 2,6"/>
                      </svg>
                      Email
                    </a>
                  )}
                  {selectedMember.linkedin && (
                    <a href={selectedMember.linkedin} target="_blank" rel="noopener noreferrer" className="contact-link linkedin">
                      <svg viewBox="0 0 24 24" fill="currentColor">
                        <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                      </svg>
                      LinkedIn
                    </a>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Members;